import { ErrorComponentProps, useNavigate } from '@tanstack/react-router'
import { ErrorScreen } from 'components/ErrorScreen'
import React from 'react'
import { styled } from 'styled-components'

const StyledErrorPageLayout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.forecast.background3};
`

const StyledGoBackButton = styled.button`
  color: ${({ theme }) => theme.forecast.activeText};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  background-color: ${({ theme }) => theme.forecast.background4};
  padding: 4px 8px;
`

export function ErrorFallback({ error }: ErrorComponentProps) {
  const navigate = useNavigate()

  let errorMessage = 'Unknown error'

  if (error instanceof Error) errorMessage = error.message
  else if (typeof error === 'string') errorMessage = error

  return (
    <StyledErrorPageLayout>
      <ErrorScreen title='There was an error' message={errorMessage}>
        <StyledGoBackButton onClick={() => navigate({ to: '/' })}>
          Go back
        </StyledGoBackButton>
      </ErrorScreen>
    </StyledErrorPageLayout>
  )
}
